import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import PublicInvitationPage from './pages/PublicInvitationPage';

console.log('🔴 PublicApp.jsx is loading');

function PublicApp() {
  console.log('🔴 PublicApp component rendering');
  
  // Set the default document title for public invitations
  useEffect(() => {
    document.title = 'Paper Plane';
  }, []);
  
  return (
    <BrowserRouter>
      <Routes>
        <Route 
          path="/:userId/:eventSlug/:invitationSlug" 
          element={<PublicInvitationPage />} 
        />
        <Route path="*" element={<div>Page not found</div>} />
      </Routes>
    </BrowserRouter>
  );
}

export default PublicApp; 